var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRocket = function SvgIconRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "m9.11 29.115 9.997-9.996 1.767 1.768-9.996 9.996z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M21.25 37.5a1.25 1.25 0 0 1-.983-.477 1.25 1.25 0 0 1-.254-.598l-1.25-8.75 2.5-.35.937 6.588 4.05-3.263v-9.4a1.25 1.25 0 0 1 .363-.887l5.087-5.088a11.17 11.17 0 0 0 3.3-7.95V5h-2.325a11.18 11.18 0 0 0-7.95 3.3l-5.087 5.088a1.25 1.25 0 0 1-.888.362h-9.4l-3.262 4.075 6.587.938-.35 2.5-8.75-1.25a1.25 1.25 0 0 1-.8-2.025l5-6.25a1.25 1.25 0 0 1 .975-.488h9.488l4.712-4.725A13.65 13.65 0 0 1 32.675 2.5H35A2.5 2.5 0 0 1 37.5 5v2.325a13.65 13.65 0 0 1-4.025 9.725l-4.725 4.713v9.487a1.25 1.25 0 0 1-.475.975l-6.25 5c-.22.176-.493.273-.775.275"
  })));
};
export default SvgIconRocket;